

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const GETCOMMENTSWITHREPLIES= createAsyncThunk(
  "getCommentsWithReplies/getCommentsWithReplies",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getCommentsWithRepliesSlice = createSlice({
  name: "getCommentsWithRepliesSlice",
  initialState: {
    getCommentsWithReplies: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetCommentsWithReplies: (state) => {
        state.getCommentsWithReplies.loading = false
        state.getCommentsWithReplies.error = false
        state.getCommentsWithReplies.data = []
        state.getCommentsWithReplies.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETCOMMENTSWITHREPLIES.fulfilled, (state, action) => {
      state.getCommentsWithReplies = {
        ...state.getCommentsWithReplies,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCOMMENTSWITHREPLIES.pending, (state, action) => {
      state.getCommentsWithReplies = {
        ...state.getCommentsWithReplies,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCOMMENTSWITHREPLIES.rejected, (state, action) => {
      state.getCommentsWithReplies = {
        ...state.getCommentsWithReplies,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getCommentsWithRepliesAction = {
    GETCOMMENTSWITHREPLIES,
};

export { getCommentsWithRepliesAction };
export default getCommentsWithRepliesSlice.reducer;
export const {setInitialStateOfgetCommentsWithReplies} = getCommentsWithRepliesSlice.actions